exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.bg-custom-green[data-v-a05b73d6] {\n  background: #6ABC45;\n  color: white;\n}\n.font-small[data-v-a05b73d6] {\n  font-size: .9rem !important;\n}\n", ""]);

// exports
